import { createContext } from 'react'
import { AuthTab } from '@app/components/blocks/authentication/authTabs'

export type AuthModalContextType = {
  withAuthCheck: <T>(action: () => Promise<T>) => Promise<T | undefined>
  checkAuth: () => boolean
  showAuthModal: (tab?: AuthTab) => void
}

export const AuthModalContext = createContext<AuthModalContextType>({
  withAuthCheck: () => undefined,
  checkAuth: () => false,
  showAuthModal: (_tab?: AuthTab) => {},
})
